import { sortValue } from 'utils';

export const columns = [
  {
    title: 'КНВЕД',
    dataIndex: 'kpved_code',
    key: 'kpved_code',
  },
  {
    title: 'ТНВЕД',
    dataIndex: 'tnved_code',
    key: 'tnved_code',
    sorter: sortValue('tnved_code'),
  },
  {
    title: 'Название',
    dataIndex: 'name',
    key: 'name',
  },
];
